/* eslint-disable no-param-reassign */

import React from 'react';

import * as c from 'constants/UI';
import {
  getGridIsOpened,
  getSelectedProductGroup,
  getSelectedProductGroupID,
} from 'reducers/UI/gridDisplay';
import { getCurrentModalPage } from 'reducers/modalPage';
import { closeModalPage } from 'actions/modalPage';
import { sleep } from 'utils';

export const openGridView = () => ({
  type: c.OPEN_GRID_VIEW,
});

export const closeGridView = () => ({
  type: c.CLOSE_GRID_VIEW,
});

export const setGridView = (
  payload: typeof c.displayView[keyof typeof c.displayView],
) => ({
  type: c.SET_GRID_VIEW,
  payload,
});

export const setProductGroup = (payload: string) => ({
  type: c.SET_PRODUCT_GROUP,
  payload,
});

export const enableProductEditMode = () => ({
  type: c.ENABLE_PRODUCT_EDIT_MODE,
});

export const disableProductEditMode = () => ({
  type: c.DISABLE_PRODUCT_EDIT_MODE,
});

export const toggleShouldGridUpdate = (payload: boolean) => ({
  type: c.SET_GRID_SHOULD_UPDATE,
  payload,
});

let lastTooltipID = 0;

export const addTooltip = ({
  content = <></>,
  selfDismiss = undefined,
}: {
  content: JSX.Element;
  selfDismiss?: number;
}) => async dispatch => {
  // dispatch(hideTooltip());
  lastTooltipID += 1;
  const id = lastTooltipID;
  dispatch({
    type: c.ADD_TOOLTIP,
    payload: { id, content },
  });
  if (selfDismiss !== undefined) {
    await sleep(selfDismiss / 1000);
    dispatch(hideTooltip(id));
  }
};

export const hideTooltip = (id: number) => async (dispatch, getState) => {
  await dispatch({
    type: c.HIDE_TOOLTIP,
    payload: { id },
  });
  const tooltipsShown = getState().UI.customerTooltip.tooltips.filter(
    ({ show }) => show,
  ).length;
  if (tooltipsShown === 0) dispatch(resetTooltips());
};

export const resetTooltips = () => ({ type: c.RESET_TOOLTIPS });

export const goUpOneProductGroup = () => async (dispatch, getState) => {
  const previousProductGroup = getSelectedProductGroup(getState())
    .parentGroupID;
  return dispatch(setProductGroup(previousProductGroup));
};

export const closeGridWithConditions = () => (dispatch, getState) => {
  const state = getState();
  const currentModal = getCurrentModalPage(state);
  const gridOnly = ['CreateNew', 'CreateNew/Item'];
  if (currentModal && gridOnly.indexOf(currentModal.component) >= 0) {
    dispatch(closeModalPage());
  }
  return dispatch(closeGridView());
};

export const setShoppingCartTooltip = (content: JSX.Element) => ({
  type: c.SET_SHOPPING_CART_TOOLTIP,
  payload: content,
});

export const setShouldUpdateGrid = (productGroupID: number) => (
  dispatch,
  getState,
) => {
  const gridIsOpen = getGridIsOpened(getState());
  const openedProductGroupID = getSelectedProductGroupID(getState());
  if (gridIsOpen && Number(openedProductGroupID) === productGroupID) {
    dispatch(toggleShouldGridUpdate(true));
  }
};
